<template>
    <ui-modal-message-v-2
        name='change-stage-status-modal'
        :cancelButton="true"
        :color-square="'primary'"
        icon-square
        :dynamicIcon="icon"
        :widthDynamicIcon="24"
        :heightDynamicIcon="16"
        @close-modal="handleCloseModal"
    >
        <template #title>
            <div class="title-container">
                <span class="first-title">{{ firstTitle }}</span>
                <span class="second-title">{{ secondTitle }}</span>
            </div>
        </template>
        <template #text>
            <div class="text-container">
                <div class="text-alert">{{ modalTextAlert }}</div>
                <div class="selects-container">
                    <div class="stage-select">
                        <ui-select-v-2
                            v-model="selectedStageId"
                            :data="filterStages"
                            label="Etapa:"
                            item-label="name"
                            return-value="id"
                        />
                    </div>
                    <div class="status-select">
                        <ui-select-v-2
                            v-model="selectedStageStatusId"
                            :data="filterStatusByStage"
                            :disabled="disabledStatus()"
                            label="Status:"
                            item-label="name"
                            return-value="id"
                        /> 
                    </div>
                </div>
            </div>
        </template>
        <template #footer>
            <ui-button
                :design="'md success'"
                @click="buttonAction"
            >
                {{ buttonText }}
            </ui-button>
        </template>
    </ui-modal-message-v-2>
</template>

<script>
    import { uiModalMessageV2 } from '@/components/ui/modal';
    import { uiSelectV2 } from '@/components/ui/form';
    import { uiButton } from '@/components/ui/buttons';

    import { funnel } from '@/services/axios'

    export default {
        name: 'change-stage-status-modal',

        components: {
            uiModalMessageV2,
            uiSelectV2,
            uiButton,
        },

        props: {
            firstTitle: {
                type: String,
                default: '',
                required: false
            },
            secondTitle: {
                type: String,
                default: '',
                required: false
            },
            modalTextAlert: {
                type: String,
                default: '',
                required: false
            },
            buttonText: {
                type: String,
                default: 'Avançar',
                required: false
            },
            closeModalAction: {
                type: Function,
                required: false
            },
            icon:{
                type: String,
                default: 'ui-allotment-icon',
                required: true
            },
            filteredAction:{
                type: Array,
                required: false
            },
            buttonAction:{
                type: Function,
                required: true
            }
        },

        data(){
            return {
                allStages: [],
                selectedStageId: null,
                selectedStageStatusId: null
            }
        },

        mounted() {
            this.$root.$on('modal-msg-open-change-stage-status-modal', this.getAllStages());
        },

        watch: {
            selectedStageId() {
                this.findSelectedAction();
            },
            selectedStageStatusId() {
                this.findSelectedAction();
            }
        },

        computed: {
            filterStages(){
                if (!Array.isArray(this.filteredAction) || this.filteredAction.length === 0) {
                    return [];
                }
                // Mapeia todos os funnel_stage_id do array filteredAction
                const stageIds = this.filteredAction.map(action => action.funnel_stage_id);
                // Filtra allStages para pegar apenas os que têm ID presente em stageIds
                return this.allStages.filter(stage => stageIds.includes(stage.id));
            },

            filterStatusByStage(){
                if (!Array.isArray(this.filteredAction) || this.filteredAction.length === 0) {
                    return [];
                }

                // Obtém os IDs dos statuses filtrados que existem em filteredAction
                const filteredStatusIds = this.filteredAction.map(action => action.funnel_stage_status_id);

                // Busca a etapa selecionada
                const selectedStage = this.allStages.find(stage => stage.id === this.selectedStageId);

                if (!selectedStage) return [];

                // Filtra os status da etapa para manter apenas os que existem em filteredStatusIds
                const filteredStatuses = selectedStage.status.filter(status => filteredStatusIds.includes(status.id));

                return filteredStatuses;
            },
        },

        methods: {
            async getAllStages(){
                await funnel.getStagesV2()
                .then((funnelResponse) => {
                    if(funnelResponse.data.status === 'success'){
                        this.allStages = funnelResponse.data.data
                    }
                })
                .catch((funnelError) => {
                    console.error(funnelError)
                })
            },

            findSelectedAction() {
                if (!this.selectedStageId) {
                    return;
                }

                if(this.selectedStageId && !this.selectedStageStatusId){
                    this.selectedStageStatusId = null
                }

                const selectedAction = this.filteredAction.find(action =>
                    action.funnel_stage_id === this.selectedStageId &&
                    action.funnel_stage_status_id === this.selectedStageStatusId
                );

                if (selectedAction) {
                    this.$emit('selected-action', selectedAction.id);
                }
            },

            disabledStatus(){
                return this.filterStatusByStage.length === 0;
            },

            handleCloseModal() {
                // Chama a função passada pela prop, se existir
                if (this.closeModalAction) {
                    this.closeModalAction();
                }

                // Limpa os selects
                this.selectedStageId = null;
                this.selectedStageStatusId = null;
            }
            
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>